import type { DataSourceEventPayload } from '@splunk/dashboard-types';
import { DS_STATUS } from '@splunk/datasource-utils';

export const getIconStatus = (
    dataSource?: DataSourceEventPayload
): 'ok' | 'warning' | 'error' | null => {
    if (!dataSource) {
        return null;
    }

    const status = dataSource?.error
        ? DS_STATUS.FAILED
        : dataSource?.meta?.status || DS_STATUS.QUEUED;

    switch (status) {
        case DS_STATUS.QUEUED:
        case DS_STATUS.PARSING:
        case DS_STATUS.RUNNING:
        case DS_STATUS.REFRESHING:
            return 'ok';
        case 'pause':
            return 'warning';
        case DS_STATUS.FAILED:
            return 'error';
        case DS_STATUS.DONE:
            // serverLog warning only gets set for the most recent search when the job is done
            if (dataSource?.meta?.serverLog?.[0]?.level === 'WARN') {
                return 'warning';
            }
            // TODO: totalCount > 10000 = results are truncated
            return dataSource.meta?.totalCount === 0 ? 'warning' : null;
        case DS_STATUS.FINALIZING:
        case DS_STATUS.CANCELED:
        default:
            return null;
    }
};
